const production = {
  SERVICE_URL: '//' + window.location.hostname + ':' + window.location.port + '/api',
  SIGNALR_URL: '//' + window.location.hostname + ':' + window.location.port + '/notification',
  USER_IDLE_TIMEOUT: 30, // in seconds
  REFRESH_TOKEN_BEFORE_EXPIRED_IN_SECONDS:30,
  STORAGE_ALMOST_FULL_THRESHOLD: 0.9,
  STORAGE_AVALIALBE_COLOR: "#00A84C",
  STORAGE_ALMOST_FULL_COLOR: "#D60042"
};

const development = {
  SERVICE_URL: '//' + window.location.hostname + ':5200/api',
  SIGNALR_URL: '//' + window.location.hostname + ':5200/notification',
  USER_IDLE_TIMEOUT: 30, // in seconds  
  REFRESH_TOKEN_BEFORE_EXPIRED_IN_SECONDS:30,
  STORAGE_ALMOST_FULL_THRESHOLD: 0.9,
  STORAGE_AVALIALBE_COLOR: "#00A84C",
  STORAGE_ALMOST_FULL_COLOR: "#D60042"
};


export default process.env.NODE_ENV === 'production' ? production : development;